import React, { useEffect, useState } from "react";
import {
  Col,
  Container,
  OverlayTrigger,
  Stack,
  Tab,
  Tabs,
  Tooltip,
} from "react-bootstrap";
import RecordListNew from "../../../../Case_Management/Case_Records/components/Record_List";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/Store";
import TranscriberUploadRecordFile from "./TranscriberUploadRecordFile";
import { TRANSCRIPTION_REPORT_STATUS } from "../../../../../common/Constant";

const TABS = ["Upload Records", "Record List"];

const TranscriberUploadRecordTabIndex: React.FC<any> = ({
  editorData,
  SelectedRowsDataTo,
  close,
}) => {
  const loggedInUserid = useSelector((state: RootState) => state.auth.userid);
  const [activeTab, setActiveTab] = useState<string>("Upload Records");
  const [selectedRecordRowData, setSelectedRecordRowData] = useState(null);
  const [isRecordRowActionTriggered, setIsRecordRowActionTriggered] =
    useState(false);
  const isCompleted = [TRANSCRIPTION_REPORT_STATUS.TRANSCRIPTION_COMPLETED].includes(
    editorData?.[0]?.transcriptionStatus,
  );
  const [isUploadButtonDisable, setIsUploadButtonDisable] =
    useState<boolean>(false);

  const caseId = editorData[0]?.caseId;
  const patient = editorData[0]?.patientName;
  const doctorName = editorData[0]?.qmeDoctorName;

  useEffect(() => {
    if (isCompleted) {
      handleRecordRowAction({
        caseRecordHeaderId:
          Number(editorData[0]?.latestCaseRecordHeaderId) || null,
      });
    }
  }, [editorData]);

  const handleRecordRowAction = (row: any) => {
    setSelectedRecordRowData(row);
    setIsRecordRowActionTriggered(true);
    setActiveTab("Upload Records");
  };

  const handleRecordTab = (shouldUploadButtonDisable: boolean) => {
    setActiveTab("Record List");
    setIsUploadButtonDisable(shouldUploadButtonDisable);
  };

  const handleRecordTabChange = (key: any) => {
    setActiveTab(key);
    if (key === "Record List") {
      setIsRecordRowActionTriggered(false);
    } else {
      if (!isRecordRowActionTriggered) {
        setSelectedRecordRowData(null);
      }
      setIsRecordRowActionTriggered(false);
    }
  };

  const handleClose = () => {
    close();
  };

  return (
    <>
      <div className="breadcrumbg pb-0">
        <Container fluid className="px-5">
          <Stack direction="horizontal" gap={2}>
            <Col className="pt-0 flex-column d-flex align-items-start fade-in-left">
              <h4>Upload & Review Records</h4>
              <Tabs
                activeKey={activeTab}
                onSelect={handleRecordTabChange}
                className="mb-0 Tab_borderBottom fade-in-right"
              >
                {TABS.map((tab) => (
                  <Tab
                    key={tab}
                    eventKey={tab}
                    title={tab}
                    disabled={
                      (isCompleted || isUploadButtonDisable) &&
                      tab === "Upload Records"
                    }
                  />
                ))}
              </Tabs>
            </Col>

            <div className="status_row">
              <h6
                className="fade-in-right mt-1 d-flex align-items-center"
                style={{ lineHeight: "15px" }}
              >
                <span className="caseinfoROR">Case ID</span>:{" "}
                <OverlayTrigger
                  placement="top"
                  overlay={
                    caseId.length > 20 ? (
                      <Tooltip id="tooltip-caseid">{caseId}</Tooltip>
                    ) : (
                      <></>
                    )
                  }
                >
                  <span className="casedetail text-truncate ms-1">
                    {caseId}
                  </span>
                </OverlayTrigger>
              </h6>

              {patient && (
                <h6 className="fade-in-right d-flex align-items-center">
                  <span className="caseinfoROR">Patient</span>:{" "}
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      patient.length > 20 ? (
                        <Tooltip id="tooltip-patient">{patient}</Tooltip>
                      ) : (
                        <></>
                      )
                    }
                  >
                    <span className="casedetail text-truncate ms-1">
                      {patient}
                    </span>
                  </OverlayTrigger>
                </h6>
              )}

              {doctorName && (
                <h6 className="fade-in-right d-flex align-items-center">
                  <span className="caseinfoROR">Doctor</span>:{" "}
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      doctorName.length > 20 ? (
                        <Tooltip id="tooltip-doctor">{doctorName}</Tooltip>
                      ) : (
                        <></>
                      )
                    }
                  >
                    <span className="casedetail text-truncate ms-1">
                      {doctorName}
                    </span>
                  </OverlayTrigger>
                </h6>
              )}
            </div>
          </Stack>
        </Container>
      </div>

      <div className="main_wrapper_section pills_wrapper px-5 mb-3 mt-3 fade-in-left">
        {activeTab === "Upload Records" && (
          <TranscriberUploadRecordFile
            caseInfoId={editorData[0]?.caseInfoId}
            userData={editorData[0]}
            loggedInUserid={loggedInUserid}
            onCancel={handleClose}
            recordActiveTab={activeTab}
            selectedRowData={selectedRecordRowData}
            onTabChange={handleRecordTab}
            isRowActionTriggered={isRecordRowActionTriggered}
            activeTab={activeTab}
            isEditorFile={true}
            isCompleted={isCompleted}
          />
        )}

        {activeTab === "Record List" && (
          <RecordListNew
            caseInfoId={editorData[0]?.caseInfoId}
            action="view"
            loggedInUserid={loggedInUserid}
            onCancel={handleClose}
            onRowSelect={handleRecordRowAction}
            recordActiveTab={activeTab}
            isEditorFile={true}
            toDosMainTab="TODO_Editor"
            selectedRORData={editorData[0]}
          />
        )}
      </div>
    </>
  );
};

export default TranscriberUploadRecordTabIndex;
